<form nz-form [formGroup]="form" nzLayout="vertical" nzSize="small">
  <page-header auto-width-header [breadcrumb]="breadcrumb" [title]="titleTpl" [content]="content" [extra]="extra"
    [action]="actionTpl">
    <ng-template #breadcrumb>
      <nz-breadcrumb>
        <nz-breadcrumb-item>
          <a [routerLink]="['/']">Home</a>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item>AR</nz-breadcrumb-item>
        <nz-breadcrumb-item>
          <a [routerLink]="['/ar/inv/list']">Invoices</a>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item>
          <span *ngIf="id === '0'">
            <i>&lt;---New---&gt;</i>
          </span>
          <span *ngIf="id !== '0'">
            <p nz-typography nzCopyable [nzContent]="dataSrv.code" class="d-inline-flex"></p>
          </span>
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </ng-template>
    <ng-template #titleTpl>
      {{ title }}
    </ng-template>
    <ng-template #actionTpl>
      <app-doc-edit-actions [onlinePayment]="true" [reportTypes]="[{ reportType: 'inv-voucher' }]"
        [allowEdit]="dataSrv._data.docType !== 'SINV' && this.isPostedFromCs === false" [sstReturnCheck]="true"
        [additionalData]="additionalData">
      </app-doc-edit-actions>
    </ng-template>
    <ng-template #content>
      <span></span>
      <nz-tag nzColor="red" *ngIf="dataSrv._data.isCancelled" nz-tooltip [nzTooltipTitle]="voidTpl">
        CANCELLED
      </nz-tag>
      <nz-tag *ngIf="dataSrv._data.docType === 'SINV' || this.isPostedFromCs === true" nzColor="success">
        <a *ngIf="dataSrv._data.docType === 'SINV'" [routerLink]="['/sale/inv/detail', id]">
          POSTED FROM SALES
        </a>
        <a *ngIf="this.isPostedFromCs === true" [routerLink]="['/sale/cs/detail', id]">
          POSTED FROM CASH SALES
        </a>
      </nz-tag>
    </ng-template>
    <ng-template #extra>
      <app-auto-code formControlName="docCode" [isNew]="id === '0'" [date]="form.value.docDate"
        [projectId]="form.value.projectId" type="INV">
      </app-auto-code>
      <app-gl-posting-modal url="api/Invoices/GLPosting" [docId]="id"></app-gl-posting-modal>
    </ng-template>
    <ng-template #voidTpl>
      <b>Cancellation Date:</b> {{ dataSrv._data.cancelledDate | date: dataSrv.dateFormat }}
      <br />
      <b>Reason:</b> {{ dataSrv._data.cancelledRemark }}
    </ng-template>
  </page-header>

  <!-- Row 1 -->
  <nz-row nzGutter="8">
    <!-- Col1 -->
    <nz-col nzXXl="10" nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <!-- Customer Row -->
      <nz-row nzGutter="4">
        <nz-col nzLg="8" nzMd="8" nzSm="8" nzXs="10">
          <nz-form-item class="customer">
            <nz-form-label nzRequired="true" nzFor="customer">Customer</nz-form-label>
            <nz-input-group nzSearch [nzAddOnAfter]="infoBtn" class="width-100">
              <nz-form-control nzErrorTip="Customer is required">
                <app-customer-select tabindex="1" app-auto-focus formControlName="customer"
                  (ngModelChange)="onCustomerChange()"></app-customer-select>
              </nz-form-control>
            </nz-input-group>
            <ng-template #infoBtn>
              <button nz-button type="button" nz-tooltip nzTooltipTitle="More Info"
                [disabled]="!form.controls.customerId.value" (click)="openCustModal()">
                <span nz-icon nzType="info-circle" nzTheme="outline"> </span>
              </button>
            </ng-template>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="16" nzMd="16" nzSm="16" nzXs="14">
          <nz-form-item>
            <nz-form-label nzFor="customerName"></nz-form-label>
            <nz-form-control>
              <app-text-input #customerNameInput tabindex="2" formControlName="customerName" maxlength="250"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <!-- Currency & Rate & Term & Agent -->
      <nz-row nzGutter="8">
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="currencyRate">Currency Rate</nz-form-label>
            <nz-input-group nzSearch [nzAddOnAfter]="latestBtn" style="width:100%">
              <nz-form-control nzErrorTip="Currency rate is required">
                <app-currency-rate formControlName="currencyRate" required="true" tabindex="5"
                  [currency]="form.controls.currency.value">
                </app-currency-rate>
              </nz-form-control>
            </nz-input-group>
            <ng-template #latestBtn>
              <button nz-button nzType="default" type="button" (click)="updateLatestRate()"
                [disabled]="!dataSrv.editing || form.controls.currency.value?.local || dataSrv.updatingRate"
                [nzLoading]="dataSrv.updatingRate" nz-tooltip nzTooltipTitle="Click to retrieve latest currency rate">
                <span nz-icon nzType="search"></span>
              </button>
            </ng-template>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="term" nzRequired>Term</nz-form-label>
            <nz-form-control nzErrorTip="Term is required">
              <app-term-select formControlName="term" valueField="" tabindex="6"></app-term-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzLg="8" nzMd="24" nzSm="24" nzXs="24" #inputWrapper data-control-name="agent">
          <nz-form-item>
            <nz-form-label nzFor="agent">Agent</nz-form-label>
            <nz-form-control nzErrorTip="Agent is required">
              <app-agent-select formControlName="agent" valueField="" tabindex="7"></app-agent-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-col>
    <!-- Col2 -->
    <nz-col nzXXl="6" nzXl="10" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="billingAddress">Billing Address</nz-form-label>
        <nz-form-control>
          <app-memo-input formControlName="billingAddress" rows="5" [maxlength]="400" tabindex="3">
          </app-memo-input>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <!-- Col3 -->
    <nz-col nzXXl="8" nzXl="14" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <!-- Date -->
      <nz-row nzGutter="8">
        <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="docDate" nzRequired>Date</nz-form-label>
            <nz-input-group nzSearch [nzAddOnAfter]="moreDateBtn" class="width-100">
              <nz-form-control nzErrorTip="Transaction Date is required">
                <app-date-input formControlName="docDate" required [nzAllowClear]="false" tabindex="4">
                </app-date-input>
              </nz-form-control>
            </nz-input-group>
            <ng-template #moreDateBtn>
              <button nz-button nzType="default" type="button"
                (click)="moreDatePicker.show(form.controls.docDate.value, null, form.controls.taxDate.value)">
                <span nz-icon nzType="ellipsis"></span>
              </button>
            </ng-template>
          </nz-form-item>
        </nz-col>
        <!-- <nz-col nzLg="12" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="taxDate" nzRequired>Tax Date</nz-form-label>
            <nz-form-control nzErrorTip="Tax Date is required">
              <app-date-input formControlName="taxDate" [nzAllowClear]="false" tabindex="5">
              </app-date-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col> -->
      </nz-row>
      <nz-row nzGutter="8">
        <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="referenceNo">Ref No.</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="referenceNo" maxlength="50" tabindex="8"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-col>
  </nz-row>

  <!-- Row2 -->
  <nz-row nzGutter="8">
    <!-- Col1 -->
    <nz-col nzXl="10" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <nz-row nzGutter="8">
        <nz-col nzLg="16" nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="description">Description</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="description" maxlength="250" tabindex="9"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col acl="m1.256" nzLg="8" nzMd="24" nzSm="24" nzXs="24" #inputWrapper data-control-name="project">
          <nz-form-item>
            <nz-form-label nzFor="project">Project</nz-form-label>
            <nz-form-control nzErrorTip="Project is required">
              <app-project-select formControlName="project" tabindex="10">
              </app-project-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-col>
    <!-- Col2 -->
    <nz-col nzLg="3" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="isTaxInclusive">Tax Inclusive</nz-form-label>
        <nz-form-control>
          <nz-switch formControlName="isTaxInclusive" tabindex="11"></nz-switch>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <!-- Col3 -->
    <nz-col nzLg="3" nzMd="24" *ngIf="this.dataSrv.country === 'PH' && this.isEnableDeferredVatLookupSrv">
      <nz-form-item>
        <nz-form-label nzFor="isDeferredTax">Deferred VAT</nz-form-label>
        <nz-form-control>
          <nz-switch formControlName="isDeferredTax" tabindex="12"></nz-switch>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <!-- Col4 -->
    <nz-col nzLg="3" nzMd="24" *ngIf="this.isPast">
      <nz-form-item>
        <nz-form-label nzFor="totalAmount">Balance</nz-form-label>
        <nz-form-control>
          <app-currency-input formControlName="totalAmount" class="text-right" tabindex="13"></app-currency-input>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <nz-col nzLg="2" nzMd="24" *ngIf="this.isPast">
      <nz-form-item>
        <nz-form-label nzFor="docTaxCode">Tax Code</nz-form-label>
        <nz-form-control>
          <app-output-tax-code-select formControlName="docTaxCode" valueField="">
          </app-output-tax-code-select>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <nz-col nzLg="3" nzMd="24" *ngIf="this.isPast">
      <nz-form-item>
        <nz-form-label nzFor="taxTotalAmount">Tax Amount</nz-form-label>
        <nz-form-control>
          <app-currency-input [allowEdit]="false" formControlName="taxTotalAmount"
            class="text-right"></app-currency-input>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>
  <nz-tabset [nzTabBarExtraContent]="toolguideTemplate">
    <ng-template #toolguideTemplate>
      <button nz-button class="toolguide-btn" type="button" (click)="toolguideModal.openModal()">
        Tool Guide
        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
      </button>
    </ng-template>
    <nz-tab *ngIf="this.isPast === false" nzTitle="Details" nzSize="small" class="editable-table">
      <nz-button-group class="float-right text-primary mb-md">
        <!-- <div>
          <button type="button" nz-button nzType="primary" (click)="columnAdjustService.resetColumnOrder(columns,'inv')">
            Reset Column
          </button>
        </div> -->
        <!-- Simple Pagination - Always Enabled -->
      </nz-button-group>
      <nz-table #linesTable formArrayName="details" [nzData]="getPaginatedData()" [nzFrontPagination]="false"
        [nzShowPagination]="false" nzBordered="true" nzSize="small" [nzScroll]="{ x: '600px', y: '600px' }">
        <thead>
          <tr cdkDropList cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="columnAdjustService.drop($event,columns, 'inv')">
            <th nzWidth="50px" [nzAlign]="'center'" *ngIf="dataSrv.editing"></th>
            <th nzWidth="48px" [nzAlign]="'center'">#</th>
            <ng-container *ngFor="let col of columns; let index = index; let last = last">
              <th [nzWidth]="$any(col)?.width" nz-resizable nzPreview (nzResizeEnd)="onResize($event, col)"
                [nzAlign]="$any(col).align ?? 'left'" cdkDrag [cdkDragDisabled]="col.key === 'account'">
                <div cdkDragHandle>
                  {{col.title}}
                </div>
                <nz-resize-handle *ngIf="!last" nzDirection="right">
                  <i></i>
                </nz-resize-handle>
                <div class="th-drag-preview" *cdkDragPreview>{{ $any(col.title).text ?? col.title }}</div>
              </th>
            </ng-container>
            <th nzWidth="60px" [nzAlign]="'center'" *ngIf="dataSrv.editing"></th>
          </tr>
        </thead>
            <tbody cdkDropList [cdkDropListData]="getPaginatedData()" (cdkDropListDropped)="onDropLine($event)" class="edit-table">

          <tr *ngFor="let line of getPaginatedData(); trackBy: trackByRow; let i = index" cdkDrag
            [cdkDragDisabled]="!dataSrv.editing" [cdkDragData]="line" [formGroupName]="getGlobalIndex(i)">
            <td class="text-center" *ngIf="dataSrv.editing">
              <span nz-icon nzType="drag" nzTheme="outline" class="drag-icon" cdkDragHandle></span>
            </td>
            <td class="text-center">{{ line.value.numbering }}</td>
            @for (col of columns; track col.key) {
            <td #editableCell [attr.data-row]="i" [attr.data-column]="col.name">
              @switch (col.name) {
              @case ('account') {
              <app-gl-acc-select formControlName="account" valueField="" labelField="code" [allowClear]="true"
                [borderless]="true" (keydown)="onKeyDown($event, getGlobalIndex(i), 'account')"
                (openChange)="$event && (recentAccountControlIndex = getGlobalIndex(i))">
              </app-gl-acc-select>
              }
              @case ('accountName') {
              <app-view-item [text]="line.value.account?.name" [borderless]="true"></app-view-item>
              }
              @case ('description') {
              <app-text-input formControlName="description" [maxlength]="250" [borderless]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'description')">
              </app-text-input>
              }
              @case ('referenceNo') {
              <app-text-input formControlName="referenceNo" [maxlength]="50" [borderless]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'referenceNo')">
              </app-text-input>
              }
              @case ('accAmount') {
              <app-currency-input formControlName="amount" [ignoreZero]="true" [borderless]="true"
                [allowEdit]="line.value.accountId" [allowNegative]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'accAmount')">
              </app-currency-input>
              }
              @case ('project') {
              <app-project-select formControlName="project" [borderless]="true"
                [allowEdit]="line.value.accountId && !form.controls.projectId.value"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'project')">
              </app-project-select>
              }
              @case ('taxCode') {
              <app-output-tax-code-select formControlName="taxCode" valueField="" [borderless]="true"
                [allowEdit]="line.value.accountId" (keydown)="onKeyDown($event, getGlobalIndex(i), 'taxCode')"
                (openChange)="$event && (recentTaxControlIndex = getGlobalIndex(i))">
              </app-output-tax-code-select>
              }
              @case ('taxExemptionRate') {
              <app-taxcode-exemptionrate-select formControlName="taxExemptionRate" [borderless]="true" [allowEdit]="line.value.accountId && line.value.taxCodeId"
                [govTaxCode]="line.value.taxCode?.govTaxCode ?? ''"/>
              }
              @case ('taxExemptionAmount') {
              <app-currency-input formControlName="taxExemptionAmount" [borderless]="true" [allowEdit]="false" [ignoreZero]="true"/>
              }
              @case ('taxAmount') {
              <app-currency-input formControlName="taxAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true">
              </app-currency-input>
              }
              @case ('tariffCode') {
              <app-tariff-tax-code-select formControlName="tariffCode" [borderless]="true"
                [allowEdit]="line.value.accountId" (keydown)="onKeyDown($event, getGlobalIndex(i), 'tariffCode')">
              </app-tariff-tax-code-select>
              }
              @case ('taxAmountAdjustment') {
              <app-currency-input formControlName="taxAmountAdjustment" [borderless]="true"
                [allowEdit]="line.value.taxCode" [ignoreZero]="true" [allowNegative]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'taxAmountAdjustment')">
              </app-currency-input>
              }
              @case ('rentalLeaseExemptedRate') {
              <app-percent-input formControlName="rentalLeaseExemptedRate" [borderless]="true"
                [allowEdit]="false" />
              }
              @case ('rentalLeaseExemptedTaxAmount') {
              <app-currency-input formControlName="rentalLeaseExemptedTaxAmount" [borderless]="true"
                [allowEdit]="false" [ignoreZero]="true" [allowNegative]="true" />
              }
              @case ('wTaxCode') {
              <app-output-wtax-code-select formControlName="wTaxCode" valueField="" [borderless]="true"
                [allowEdit]="line.value.accountId" (keydown)="onKeyDown($event, getGlobalIndex(i), 'wTaxCode')">
              </app-output-wtax-code-select>
              }
              @case ('wTaxAmount') {
              <app-currency-input formControlName="wTaxAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true" [allowNegative]="true">
              </app-currency-input>
              }
              @case ('wTaxAmountAdjustment') {
              <app-currency-input formControlName="wTaxAmountAdjustment" [borderless]="true"
                [allowEdit]="line.value.wTaxCode" [ignoreZero]="true" [allowNegative]="true"
                (keydown)="onKeyDown($event, getGlobalIndex(i), 'wTaxAmountAdjustment')">
              </app-currency-input>
              }
              @case ('wVatCode') {
              <app-wtax-code-select formControlName="wVatCode" [wvatOnly]="true" [borderless]="true"
                [allowEdit]="line.value.accountId" (keydown)="onKeyDown($event, getGlobalIndex(i), 'wVatCode')">
              </app-wtax-code-select>
              }
              @case ('wVatRate') {
              <app-currency-input formControlName="wVatRate" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true"></app-currency-input>
              }
              @case ('wVatAmount') {
              <app-currency-input formControlName="wVatAmount" [borderless]="true" [allowEdit]="false"
                [ignoreZero]="true"></app-currency-input>
              }
              }
            </td>
            }
            <td class="text-center" *ngIf="dataSrv.editing">
              <!-- <a nz-popconfirm nzPopconfirmTitle="Are you sure to remove this item?"
                (nzOnConfirm)="removeLineAtGlobalIndex(getGlobalIndex(i))">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </a> -->
              <a (click)="removeLineAtGlobalIndex(getGlobalIndex(i))">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <!-- Pagination Controls - Under Table -->
      <div class="pagination-container" *ngIf="totalRowCount > 0">
        <div class="pagination-wrapper">
          <!-- Summary Text -->
          <div class="pagination-summary">
            {{ getPaginationSummary() }}
          </div>

          <!-- Page Navigation -->
          <div class="pagination-nav">
            <button type="button" nz-button nzType="text" [disabled]="currentPage === 1" (click)="prevPage()"
              class="nav-btn prev-btn">
              <span nz-icon nzType="left"></span>
            </button>

            <div class="page-numbers">
              @for (page of getPageNumbers(); track page) {
              @if (page === '...') {
              <span class="page-ellipsis">...</span>
              } @else {
              <button type="button" nz-button nzType="text" [nzSize]="'small'" [class.active-page]="page === currentPage"
                (click)="goToPage(+page)" class="page-number">
                {{ page }}
              </button>
              }
              }
            </div>

            <button type="button" nz-button nzType="text" [disabled]="currentPage === totalPages" (click)="nextPage()"
              class="nav-btn next-btn">
              <span nz-icon nzType="right"></span>
            </button>
          </div>

          <!-- Items per page selector -->
          <div class="items-per-page">

            <!-- Fallback simple select -->
            <select [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}"
              (change)="onPageSizeChange($any($event.target).value)">
              <option value="10" [selected]="pageSize === 10">10 / page</option>
              <option value="20" [selected]="pageSize === 20">20 / page</option>
              <option value="50" [selected]="pageSize === 50">50 / page</option>
            </select>

          </div>
        </div>
      </div>

      <!-- Add Lines Button -->
      <button type="button" nz-button [nzType]="'dashed'" (click)="addLines()" nzBlock class="mt-md"
        *ngIf="dataSrv.editing" [disabled]="!dataSrv.isTaxDateValid">
        <i nz-icon nzType="plus"></i>
        <span>Add Lines</span>
      </button>
    </nz-tab>
    <nz-tab nzTitle="BIR" *ngIf="this.dataSrv.country === 'PH'">
      <app-bir-2307-collected-attachment #birComponent [type]="['Inv']" [referenceId]="id"
        [eventTriggered]="dataSrv.eventTrigger"        [disabled]="!dataSrv.editing" 
        [isBIR2307Collected]="dataSrv.form.controls.isBIR2307Collected.value ? true : false"
        (isBIR2307CollectedChange)="dataSrv.form.controls.isBIR2307Collected.setValue($event)"
        [biR2307CollectedDate]="dataSrv.form.controls.biR2307CollectedDate.value"
        (biR2307CollectedDateChange)="dataSrv.form.controls.biR2307CollectedDate.setValue($event)">
      </app-bir-2307-collected-attachment>
    </nz-tab>
    <nz-tab *ngIf="id !== '0'" nzTitle="Payment Info" nzSize="small" class="editable-table"
      (nzClick)="dataSrv.loadPaymentInfo(cdr)">
      <nz-spin [nzSpinning]="dataSrv.paymentInfoLoading">
      <st #st resizable responsive="false" [page]="dataSrv.page" [widthMode]="{ type: 'strict' }"
        [data]="dataSrv.paymentInfoItems" [columns]="dataSrv.paymentInfoColumns" [scroll]="{ x: '800px', y: '400px' }">
        <ng-template st-row="dateTpl" let-item let-index="docId">
          {{ item.paymentDate | customDate }}
        </ng-template>
        <ng-template st-row="doccodeTpl" let-item let-index="docId">
          <a (click)="dataSrv.openDoc(item)">{{ item.paymentDocCode }}</a>
        </ng-template>
        <ng-template st-row="amtTpl" let-item let-index="docId">
          {{ item.paymentAmount | price }}
        </ng-template>
        <!-- <ng-template st-row="paymTpl" let-item let-index="docId">
          <div *ngFor="let tag of paymTag">
            <nz-tag *ngIf="item.eInvoicePaymentMode == tag.value">{{
              tag.value + ' ' + tag.name
            }}</nz-tag>
          </div>
        </ng-template> -->
      </st>
      </nz-spin>
      <nz-space nzAlign="end"></nz-space>
      <app-tranx-summary [netTotalAmount]="form.controls.netTotalAmount.value"
        [outstandingAmount]="form.controls.outstandingAmount.value" [showTotalPaid]="true">
      </app-tranx-summary>
    </nz-tab>
    <nz-tab [nzTitle]="AttachmentsTittle">
      <ng-template #AttachmentsTittle>
        <nz-badge class="attachment-badge" [nzCount]="attachmentTable.attachmentCount" [nzOffset]="[7,2]"
          [nzSize]="'small'">
          <div>
            Attachments
          </div>
        </nz-badge>
      </ng-template>
      <app-attachment-table #attachmentTable [eventTriggered]="dataSrv.eventTrigger" [referenceId]="id"
        [type]="['Inv', 'Sinv', 'Cs']" [disabled]="!dataSrv.editing" [birComponent]="birComponent"></app-attachment-table>
    </nz-tab>
    <nz-tab [nzTitle]="TabTittle">
      <ng-template #TabTittle>
        <div>
          Notes
          <span *ngIf="form.controls.notes.value">...</span>
        </div>
      </ng-template>
      <nz-row>
        <nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-control>
              <app-memo-input #textArea formControlName="notes" rows="4" [maxlength]="5000"></app-memo-input>

            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzSpan="24">
          <button type="button" nz-button (click)="timestamp()" [disabled]="!dataSrv.editing">
            <span nz-icon nzType="plus" nzTheme="outline"></span> TimeStamp
          </button>
        </nz-col>
      </nz-row>
    </nz-tab>
  </nz-tabset>
</form>
<nz-divider></nz-divider>
<app-tranx-summary [currency]="form.controls.currency.value?.code" [totalAmount]="form.controls.totalAmount.value"
  [amountExemptedFromTax]="form.controls.amountExemptedFromTax.value"
  [subTotalAmount]="form.controls.subtotalAmount.value"
  [taxExemptionTotalAmount]="form.controls.taxExemptionTotalAmount.value"
  [taxable]="form.controls.taxExclusiveTotalAmount.value" [taxAmount]="form.controls.taxTotalAmount.value"
  [wtaxAmount]="form.controls.wTaxTotalAmount.value" [wvatAmount]="form.controls.wVatTotalAmount.value"
  [netTotalAmount]="form.controls.netTotalAmount.value" [hideTotal]="true" [showWVat]="this.isGovBirCat">
</app-tranx-summary>

<app-customer-info-modal #custModal> </app-customer-info-modal>
<app-toolguide-modal #toolguideModal></app-toolguide-modal>

<app-more-date-picker #moreDatePicker (taxDateChange)="this.dataSrv.form.controls.taxDate.setValue($event)"
  [disabled]="!dataSrv.editing"></app-more-date-picker>